import { SVGProps } from "react";
import { fluid } from "~/styles/functions";

interface Props extends SVGProps<SVGSVGElement> {}

const DrawnCircle = (props: Props) => (
  <svg
    viewBox="0 0 24 25"
    fill="none"
    strokeWidth={1.5}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.0703 12.8227L23.8846 14.023L23.8261 15.2402L23.7538 16.4943L23.1312 17.5837L22.5189 18.6495L21.8585 19.6885L21.1327 20.6905L20.4137 21.7496L19.1685 22.2102L18.0368 22.7146L16.9498 23.266L15.8697 23.8813L14.7551 24.5941L13.4789 24.7756L12.1924 24.7185L10.9162 24.6949L9.71228 24.2377L8.40169 24.2276L7.411 23.3198L6.09697 23.1416L4.96525 22.5464L4.13624 21.568L3.02172 20.8956L2.7087 19.5574L1.82465 18.6731L0.885563 17.7451L0.95436 16.3935L0.479658 15.257L0.558775 14.0197L0.469338 12.8227L0.0703125 11.5753L0.231987 10.338L0.68605 9.1679L1.25707 8.06171L1.46346 6.76723L2.33031 5.81906L3.34507 5.03565L4.28416 4.23543L5.24732 3.47891L6.11761 2.53747L7.21837 1.902H8.56336L9.64004 1.08833L10.9472 1.25308L12.1924 0.775635L13.4239 1.38421L14.6829 1.37412L15.8318 1.87846L16.9945 2.28194L18.3911 2.33237L19.4781 3.02164L20.3931 3.92273L21.1017 4.98522L22.1405 5.75854L22.7391 6.87146L23.1519 8.05162L23.4271 9.25532L24.0566 10.3582L23.9155 11.619L24.0703 12.8227Z"
      fill="white"
      className={props.className}
      style={{ transition: "fill 0.2s" }}
    />
  </svg>
);

export default DrawnCircle;
